class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;

    this.summaryToggle.addEventListener('click', (event) => event.preventDefault());

    this.detailsContainer.setAttribute('open', true);

    if (this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('empty', true);
    }
  }
}

customElements.define('footer-accordion', FooterAccordion);